import { Tooltip } from "antd";
import { svg } from "../../Assets/svg";
import { useEffect, useState } from "react";
import { useOutletContext } from "react-router-dom";

const FullScreenButton = ({ svgSizeClass }: any) => {
  const { isFullScreen, setIsFullScreen } = useOutletContext<any>();

  const [isMobile, setIsMobile] = useState(window.innerWidth < 1200);

  useEffect(() => {
    const handleResize = () => setIsMobile(window.innerWidth < 1200);
    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, []);
  useEffect(() => {
    const handleKeyDown = (e: KeyboardEvent) => {
      if (e.key === "F11") {
        e.preventDefault();
        if (!document.fullscreenElement && !isFullScreen) {
          document.documentElement.requestFullscreen().catch((err) => {
            console.error(
              `Error attempting to enable fullscreen: ${err.message}`,
            );
          });
        } else {
          if (document.exitFullscreen) {
            document.exitFullscreen();
          }
        }
      }
    };

    const handleFullscreenChange = () => {
      setIsFullScreen(!!document.fullscreenElement);
    };

    window.addEventListener("keydown", handleKeyDown);
    document.addEventListener("fullscreenchange", handleFullscreenChange);

    return () => {
      window.removeEventListener("keydown", handleKeyDown);
      document.removeEventListener("fullscreenchange", handleFullscreenChange);
    };
  }, []);

  return isMobile ? (
    <></>
  ) : (
    <>
      <div
        role="button"
        className={`filterButton position-relative ${
          svgSizeClass ? svgSizeClass : ""
        }`}
        onClick={(e) => {
          e.preventDefault();
          if (!document.fullscreenElement) {
            document.documentElement.requestFullscreen().catch((err) => {
              console.error(
                `Error attempting to enable fullscreen: ${err.message}`,
              );
            });
          } else {
            if (document.exitFullscreen) {
              document.exitFullscreen();
            }
          }
          setIsFullScreen(!isFullScreen);
        }}
      >
        <Tooltip title={isMobile ? "" : isFullScreen ? "Collapse" : "Expand"}>
          {isFullScreen ? svg?.fullCollapseIcon : svg?.fullExpandIcon}
        </Tooltip>
      </div>
    </>
  );
};

export default FullScreenButton;
